/*
*
* Global constants
*
*/

// the "global" Eiis event types
export const STORE_LOADED = "storeLoadedEvent";
export const STORE_ERROR = "storeErrorEvent";
export const STATE_CHANGED = "stateChangedEvent";
export const STORE_REFRESH = "storeRefreshEvent";
export const STORE_FILTER = "storeFilterEvent";
export const STORE_ADD_RECORD = "storeAddRecordEvent";
export const NOTIFICATIONS_SHOW = "notificationsShowEvent";
export const NOTIFICATIONS_HIDE = "notificationsHideEvent";
export const NOTIFICATIONS_CANCEL = "notificationsCancelEvent";
export const NOTIFICATION_ADD = "notificationsAddEvent";
export const NOTIFICATION_MARK = "notificationsMarkEvent";
export const NOTIFICATION_REMOVE = "notificationsRemoveEvent";
export const GRID_HEADER_CLICK = "gridHeaderClickedEvent";
export const GRID_RECORD_CLICK = "gridRecordClickedEvent";
export const BLOG_POST_CLICK = "blogRecordClickedEvent";
export const BLOG_ADD_POST = "blogAddPostEvent";
export const BLOG_EDIT_POST = "blogEditPostEvent";
export const BLOG_LIKE_POST = "blogLikePostEvent";
export const BLOG_COMMENT_POST = "blogCommentPostEvent";
export const BLOG_EDIT_COMMENT = "blogEditCommentEvent";
export const DIALOG_SHOW = "dialogShowEvent";
export const DIALOG_HIDE = "dialogHideEvent";
export const DIALOG_CANCEL = "dialogCancelEvent";
export const DIALOG_SAVE = "dialogSaveEvent";
export const DIALOG_DELETE = "dialogDeleteEvent";
export const SPINNER_ADD = "spinnerAddEvent";
export const SPINNER_REMOVE = "spinnerRemoveEvent";
export const MENU_ADD_ITEM = "menuAddItem";
export const ROUTER_LOAD_VIEW = "routerLoadView";
export const SUBMIT_LOGIN = "userLoginSubmit";
export const USER_LOGIN = "userLoggedIn";
export const USER_LOGOUT = "userLoggedOut";
export const LOGIN_ERROR = "userLoginError";
export const DROPDOWN_SELECTED = "dropdownSelectedEvent";
export const FORM_COMMIT = "formCommitEvent";
export const TOGGLE_DRAWER = "togglePageDrawer";
export const TOGGLE_NAVBAR= "toggleNavbar";
export const REPAINT_DRAWER = "repaintDrawer";
export const COOKIE_ACCEPT = "cookieAccept";

export const KEYUP_EVENT = "keyup";

export const ENTER_KEY = 13;
export const ESCAPE_KEY = 27;
export const TAB_KEY = 9;
